import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@core/environments/environment';
import { LoadingService } from './loading.service';
import { finalize, Observable } from 'rxjs';
import { Pagination } from '@core/models/pagination.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  BASE_URL = environment.ADMIN_BASE_URL + '/v1/config';

  http = inject(HttpClient);
  private loadingService = inject(LoadingService);

  constructor() {}

  getConfigList(page?: Pagination, search?: string): Observable<ConfigListResponse> {
    const uniqueStateUrl = 'get-config-list';
    this.loadingService.setLoading(uniqueStateUrl, true);
    
    let params = new HttpParams();
    
    if (page) {
      params = params
        .set('take', page.size.toString())
        .set('skip', page.skip.toString());
    }

    if (search) {
      params = params.set('search_text', search);
    }

    return this.http
      .get<ConfigListResponse>(`${this.BASE_URL}/get-all-configs`, { params })
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  updateConfig(payload: any): Observable<any> {
    const uniqueStateUrl = 'update-configuration';
    this.loadingService.setLoading(uniqueStateUrl, true);
    return this.http
      .post<any>(this.BASE_URL + '/update-config', payload)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
}


interface ConfigListResponse {
  status: string;
  data: {
    total_count: number;
    configs: Config[];
  };
}
interface Config {
  id: string;
  key: string;
  value: string;
  created_at: string;
  updated_at: string;
}
